import { render, staticRenderFns } from "./AdminUsersList.vue?vue&type=template&id=50234afa&"
import script from "./AdminUsersList.vue?vue&type=script&lang=js&"
export * from "./AdminUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports